export default function ValuesSection() {
  const values = [
    {
      title: "Collaboration",
      description: "We believe in the power of working together across disciplines to achieve better health outcomes for people and animals.",
      icon: "ri-team-line",
      color: "blue"
    },
    {
      title: "Excellence",
      description: "We are committed to the highest standards in professional practice, education, and service delivery.",
      icon: "ri-award-line",
      color: "green"
    },
    {
      title: "Innovation",
      description: "We embrace new ideas, technologies, and approaches that advance healthcare for both humans and animals.",
      icon: "ri-lightbulb-line",
      color: "purple"
    },
    {
      title: "Integrity",
      description: "We conduct ourselves with honesty, transparency, and ethical responsibility in all our professional activities.",
      icon: "ri-shield-check-line",
      color: "red"
    },
    {
      title: "Compassion",
      description: "We approach healthcare with empathy and understanding, recognizing the deep bonds between people and their pets.",
      icon: "ri-heart-line",
      color: "pink"
    },
    {
      title: "Advocacy",
      description: "We actively promote policies and practices that benefit the health and wellbeing of our communities.",
      icon: "ri-megaphone-line",
      color: "orange"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These fundamental principles guide everything we do and shape our commitment to excellence in healthcare.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className={`w-16 h-16 bg-${value.color}-100 rounded-full flex items-center justify-center mx-auto mb-6`}>
                <i className={`${value.icon} text-2xl text-${value.color}-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-4">
                {value.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}